import { PaginationState } from '@tanstack/react-table';
import { action, makeAutoObservable, observable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export class DataTableState {
    @observable public pageIndex: number = 0;
    @observable public pageSize: number = 20;
    public pageSizeState = FormInputState.new('20');

    public constructor() {
        makeAutoObservable(this);
    }

    @action public onPaginationChange = (pagination: PaginationState): void => {
        this.pageIndex = pagination.pageIndex;
        this.pageSize = pagination.pageSize;
        this.pageSizeState.setValue(pagination.pageSize.toString());
    };
}
